import React from "react";
import { motion, AnimatePresence } from "framer-motion";

const MOODS = {
  neutral: { label: "Dengeli", bg: "linear-gradient(180deg,#F9F8F6,transparent)", accent: "#0A0A0A" },
  happy: { label: "Neşeli", bg: "linear-gradient(180deg,#FFF7C2,transparent)", accent: "#CC9F00" },
  romantic: { label: "Romantik", bg: "linear-gradient(180deg,#FFD9E8,transparent)", accent: "#E43385" },
  tense: { label: "Gergin", bg: "linear-gradient(180deg,#FFE0DC,transparent)", accent: "#FF3B30" },
  sad: { label: "Hüzünlü", bg: "linear-gradient(180deg,#E5E5F0,transparent)", accent: "#7A7A9F" },
  playful: { label: "Oyuncu", bg: "linear-gradient(180deg,#E7FFCF,transparent)", accent: "#5C9A00" },
  urgent: { label: "Acil", bg: "linear-gradient(180deg,#FFE7CC,transparent)", accent: "#FF7A00" },
};

export function moodStyleFor(mood) {
  return MOODS[mood] || MOODS.neutral;
}

export default function MoodIndicator({ mood, emoji, reason, onRefresh, loading }) {
  const s = moodStyleFor(mood);
  const moodKey = mood || "neutral";
  return (
    <div
      data-testid="mood-indicator"
      className="flex items-center gap-1.5 border-hard-2 rounded-full pl-1.5 pr-2 py-1 shadow-hard-sm shrink-0"
      style={{ background: "white", borderColor: s.accent, transition: "border-color 400ms ease" }}
      title={reason ? `${s.label}: ${reason}` : `Sohbet ruh hali: ${s.label}`}
    >
      <AnimatePresence mode="wait" initial={false}>
        <motion.span
          key={moodKey}
          initial={{ scale: 0.6, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.6, opacity: 0 }}
          transition={{ duration: 0.25 }}
          className="text-base inline-block leading-none"
          style={{ filter: "drop-shadow(1px 1px 0 rgba(0,0,0,0.2))" }}
        >
          {emoji || "💬"}
        </motion.span>
      </AnimatePresence>
      <div className="flex flex-col leading-none overflow-hidden">
        <span className="text-[9px] uppercase font-black tracking-widest text-[#555] hidden sm:block">Ruh hali</span>
        <span
          className="text-[11px] sm:text-xs font-black"
          data-testid="mood-label"
          style={{ color: s.accent, transition: "color 300ms ease" }}
        >
          {s.label}
        </span>
      </div>
      <button
        onClick={onRefresh}
        data-testid="mood-refresh-btn"
        disabled={loading}
        className="text-[10px] font-black uppercase tracking-widest border-hard-2 rounded-full w-6 h-6 flex items-center justify-center press-btn disabled:opacity-60"
        title="Yenile"
        aria-label="Ruh halini yenile"
      >
        <span className={loading ? "inline-block animate-spin" : "inline-block"}>
          {loading ? "⟳" : "↻"}
        </span>
      </button>
    </div>
  );
}
